import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './InsightsTeaser.module.css';

export const InsightsTeaser: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className={styles.insights} id="insights">
      <div className={styles.insights__container}>
        <div className={styles.insights__header}>
          <span className={styles.insights__eyebrow}><Sparkles size={14} />{t.insightsTeaser.tag}</span>
          <h2 className={styles.insights__title}>{t.insightsTeaser.title}</h2>
          <p className={styles.insights__subtitle}>
            {t.insightsTeaser.subtitle}
          </p>
        </div>
        <div className={styles.insights__grid}>
          {t.insightsTeaser.items.map((item, idx) => (
            <Link key={item.title} to={item.href} className={styles.insights__cardLink}>
              <motion.div
                className={styles.insights__card}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.15, delay: idx * 0.05 }}
              >
                <span className={styles.insights__eyebrowCard}>{item.eyebrow}</span>
                <h3 className={styles.insights__cardTitle}>{item.title}</h3>
                <p className={styles.insights__cardText}>{item.desc}</p>
                <span className={styles.insights__link}>{t.insightsTeaser.cta}</span>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsTeaser;
